import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';
import CalendarComp from 'components/CalendarAuth/CalendarAuth';
import googleApi from 'api/google-api';
import _get from 'lodash/get';
import { calendarSignedOut } from 'actions/Calendar';
import { calendars } from 'constants/Calendar';
import icon from '@lifesize/ux-assets/vectors/svgSpecial/googleCalendar.svg';

const messages = defineMessages({
  googleCalendar: {
    id: 'components.calendar.google',
    defaultMessage: 'Google Calendar'
  }
});

const mapDispatchToProps = (dispatch) => ({
  authorize: () => {
    if (_get(window, 'desktopApp.startOAuthFlow')) {
      return window.desktopApp.startOAuthFlow(calendars.google);
    }
    return googleApi.googleAuthorize();
  },
  signout: () => {
    if (_get(window, 'desktopApp.calendarSetCredentials')) {
      dispatch(calendarSignedOut(calendars.google));
      return window.desktopApp.calendarSetCredentials(calendars.google, {});
    }
    return googleApi.googleSignout();
  }
});

function mapStateToProps(state, { intl }) {
  const isAuthorized = _get(state, 'app.calendar.google.calendarSignedIn');
  const accountName = _get(state, 'app.calendar.google.calendarUser');
  const calendarName = intl.formatMessage(messages.googleCalendar);

  return {
    isAuthorized,
    accountName,
    calendarName,
    icon
  };
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(CalendarComp));
